import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../AppClient";
import { Spinner, Alert, Card, Row, Col, Container } from "react-bootstrap";
import { CURRENCY } from "../../constants/Constants";

function Supplier() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [supplierData, setSupplierData] = useState({
    name: "",
    phone: "",
    dateoflastorder: "",
    total_purshases: "",
    remaining_balance: "",
  });

  useEffect(() => {
    fetchSupplier();
  }, [id]);

  const fetchSupplier = async () => {
    try {
      const response = await apiClient.get(`/suppliers/${id}/`);
      setSupplierData(response.data);
      setError(null);
    } catch (error) {
      if (error.response) {
        setError(error.response.data.detail || "An error occurred while fetching supplier data.");
      } else {
        setError("An error occurred while connecting to the server.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-4">
        <Alert variant="danger" className="text-center">
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="">
      <h2 className="text-center mb-4">تفاصيل المورد</h2>
      <Card className="shadow">
        <Card.Header className="bg-success" >
          <h4 className="mb-0">{supplierData.name}</h4>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={6} className="mb-3">
              <strong>رقم المورد:</strong>
              <p className="text-muted">{id}</p>
            </Col>
            <Col md={6} className="mb-3">
              <strong>اسم المورد:</strong>
              <p className="text-muted">{supplierData.name}</p>
            </Col>
            <Col md={6} className="mb-3">
              <strong>رقم الهاتف:</strong>
              <p className="text-muted">{supplierData.phone}</p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6} className="mb-3">
              <strong>تاريخ آخر شراء:</strong>
              <p className="text-muted">{supplierData.dateoflastorder}</p>
            </Col>
            <Col md={6} className="mb-3">
              <strong>مجموع قيمة المشتريات:</strong>
              <p className="text-muted">{supplierData.total_purshases} {CURRENCY}</p>
            </Col>
            <Col md={6} className="mb-3">
              <strong>مبلغ متبقي:</strong>
              <p className="text-muted">{supplierData.remaining_balance} {CURRENCY}</p>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Supplier;